import { render, staticRenderFns } from "./change-password.component.vue?vue&type=template&id=59f2589c&scoped=true"
import script from "./change-password.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./change-password.component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./change-password.component.vue?vue&type=style&index=0&id=59f2589c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f2589c",
  null
  
)

export default component.exports